import api from './api';

const dashboardService = {
  /**
   * Crear un nuevo layout de dashboard
   */
  async createLayout(layoutData) {
    try {
      const response = await api.post('/dashboard/layouts', layoutData);
      return {
        success: true,
        layout: response.data.data || response.data
      };
    } catch (error) {
      console.error('Error creating layout:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear el layout'
      };
    }
  },

  /**
   * Obtener todos los layouts del usuario
   */
  async getUserLayouts() {
    try {
      const response = await api.get('/dashboard/layouts');
      return {
        success: true,
        layouts: response.data.data || response.data
      };
    } catch (error) {
      console.error('Error fetching layouts:', error);
      return {
        success: false,
        layouts: [],
        message: error.response?.data?.message || 'Error al obtener layouts'
      };
    }
  },

  /**
   * Obtener el layout por defecto
   */
  async getDefaultLayout() {
    try {
      const response = await api.get('/dashboard/layouts/default');
      return {
        success: true,
        layout: response.data.data || response.data
      };
    } catch (error) {
      console.error('Error fetching default layout:', error);
      return {
        success: false,
        layout: null,
        message: error.response?.data?.message || 'Error al obtener layout por defecto'
      };
    }
  },

  /**
   * Obtener un layout específico
   */
  async getLayout(id) {
    try {
      const response = await api.get(`/dashboard/layouts/${id}`);
      return {
        success: true,
        layout: response.data
      };
    } catch (error) {
      console.error('Error fetching layout:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener layout'
      };
    }
  },

  /**
   * Actualizar un layout
   */
  async updateLayout(id, updates) {
    try {
      const response = await api.put(`/dashboard/layouts/${id}`, updates);
      return {
        success: true,
        layout: response.data.data || response.data
      };
    } catch (error) {
      console.error('Error updating layout:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar layout'
      };
    }
  },

  /**
   * Eliminar un layout
   */
  async deleteLayout(id) {
    try {
      const response = await api.delete(`/dashboard/layouts/${id}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error deleting layout:', error);
      return {
        success: false,
        message: error.response?.data?.error?.message || error.response?.data?.message || 'Error al eliminar layout'
      };
    }
  },

  /**
   * Duplicar un layout
   */
  async duplicateLayout(id, newName) {
    try {
      const response = await api.post(`/dashboard/layouts/${id}/duplicate`, { name: newName });
      return {
        success: true,
        layout: response.data
      };
    } catch (error) {
      console.error('Error duplicating layout:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al duplicar layout'
      };
    }
  },

  /**
   * Obtener widgets disponibles según el rol del usuario
   */
  async getAvailableWidgets() {
    try {
      const response = await api.get('/dashboard/widgets/available');
      return {
        success: true,
        widgets: response.data.data || response.data // Manejar ambos formatos
      };
    } catch (error) {
      console.error('Error fetching available widgets:', error);
      return {
        success: false,
        widgets: [],
        message: error.response?.data?.message || 'Error al obtener widgets disponibles'
      };
    }
  }
};

export default dashboardService;

